/* Catalog image failures stay honest. No guessed URLs or network retries. */
(() => {
  if (window.oxpCatalogImagesReady) return;
  window.oxpCatalogImagesReady = true;

  function showMissing(image) {
    if (!(image instanceof HTMLImageElement)) return;
    const frame = image.closest('[data-catalog-image-frame]');
    if (!frame) return;
    // An optional hover image must not hide a working primary photograph.
    if (image.hasAttribute('data-catalog-secondary-image')) {
      image.hidden = true;
      frame.classList.add('oxp-catalog-secondary-unavailable');
      return;
    }
    const status = frame.querySelector('[data-catalog-image-status]');
    if (!status) return;
    frame.classList.add('oxp-catalog-image-unavailable');
    status.hidden = false;
  }

  function inspect(root) {
    const images = root.matches?.('[data-catalog-image-frame] img') ? [root] : [];
    root.querySelectorAll?.('[data-catalog-image-frame] img').forEach(image => images.push(image));
    images.forEach(image => {
      if (image.complete && image.currentSrc && image.naturalWidth === 0) showMissing(image);
    });
  }

  document.addEventListener('error', event => showMissing(event.target), true);
  inspect(document);
  // Native facets and variant updates replace markup after initial load.
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) inspect(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
